import { Reception, ReceptionDetail } from "../reception";
import { ManagerReference, ReceptionOperation } from "../items";
import { FormatReference } from "../../format";
import { ReceptionReferenceDispInfo } from "./ReceptionReferenceDispInfo";
import { DocumentSummary, ReferenceFileInformation } from "../../document";
import { FormatStatusKinds } from "../kinds";
import { WorkflowReference } from ".";

// 依頼一式model
export class ReceptionReference {
  constructor() {
    this.reception = new Reception();
    this.receptionDetail = new ReceptionDetail();
    this.requestSheetFormats = [];
    this.requestSheetFormatStatus = FormatStatusKinds.Available;
    this.requestSheetDocument = null;
    this.requestSheetReferenceFiles = [];
    this.document = null;
    this.documentReferenceFiles = [];
    this.displayInfo = new ReceptionReferenceDispInfo();
    this.workflow = new WorkflowReference();
    this.operationHistories = [];
    this.managersHistories = [];
    this.quoteSourceDocument = null;
    this.receiptFormatOriginalIds = [];
  }
  public reception: Reception;
  public receptionDetail: ReceptionDetail;
  public requestSheetFormats: FormatReference[];
  public requestSheetFormatStatus: FormatStatusKinds;
  public requestSheetDocument: DocumentSummary;
  public requestSheetReferenceFiles: ReferenceFileInformation[];
  public document: DocumentSummary;
  public documentReferenceFiles: ReferenceFileInformation[];
  public displayInfo: ReceptionReferenceDispInfo;
  public workflow: WorkflowReference;
  public operationHistories: ReceptionOperation[];
  public managersHistories: ManagerReference[];
  public quoteSourceDocument: DocumentSummary; // 引用元文書
  public receiptFormatOriginalIds: number[];
}
